

export const displayLoadingAction = {
    type: "DISPLAY_LOADING"
}
export const hideLoadingAction = {
    type: "HIDE_LOADING"
}

